module.exports = __webpack_public_path__ + "img/logo.96cf0dea.png";